import { FC, useContext } from 'react';
import GraduateUserContext, { GraduateUserProvider, EGraduateUserUiState } from '../../contexts/GraduateUserContext';
import PageLayout from '../../layout/PageLayout/PageLayout';
import CardLoader from '../../components/Loader/Loader';
import { ERoutes } from '../../util/constants';
import { Redirect, Switch, Route } from 'react-router';
import GraduateUserSuccess from '../../components/GraduateUserSuccess/GraduateUserSuccess';
import GraduateUserForm from '../../components/GraduateUserForm/GraduateUserForm';

const GraduateUserRouter: FC = () => {
    return (
        <Switch>
            <Route exact path={ERoutes.graduateUser}>
                <GraduateUserForm />
            </Route>
            <Route path={ERoutes.graduateUserSuccess}>
                <GraduateUserSuccess />
            </Route>
        </Switch>
    );
};

const GraduateUserUi: FC = () => {
    const { graduateUserUiState } = useContext(GraduateUserContext);
    switch (graduateUserUiState) {
        case EGraduateUserUiState.default:
        case EGraduateUserUiState.queryStringParsed:
            return <CardLoader />;
        case EGraduateUserUiState.ready:
        case EGraduateUserUiState.loading:
        case EGraduateUserUiState.softError:
            return <GraduateUserRouter />;
        case EGraduateUserUiState.success:
            return (
                <>
                    <Redirect to={ERoutes.graduateUserSuccess} />
                    <GraduateUserRouter />
                </>
            );
        case EGraduateUserUiState.fatalError:
            return <Redirect to={ERoutes.error} />;
        default:
            throw new Error('Graduate User Ui State Set Incorrectly');
    }
};

const GraduateUserScreen: FC = () => {
    return (
        <GraduateUserProvider>
            <PageLayout>
                <GraduateUserUi />
            </PageLayout>
        </GraduateUserProvider>
    );
};

export default GraduateUserScreen;
